module.exports = __webpack_public_path__ + "img/extended.c04251f9.png";